// Coordenadas da localização especificada
var latitude = $("#lat").val();
var longitude = $("#lng").val();

let iconWidthAndHeight = [
    screen.width > 992 ? 69 : 45,
    screen.width > 992 ? 69 : 45,
];

// Criando o mapa com base nas coordenadas especificadas
var map = L.map('mapa', {
    closePopupOnClick: false
}).setView([latitude, longitude], 14);

// Desabilitar o scroll do mouse
map.scrollWheelZoom.disable();

// Criando uma camada de mapa
var layer = new L.TileLayer(
   "http://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png", {
        maxZoom: 16
   }
);
// Adicionando a camada ao mapa
map.addLayer(layer);

let customIcon = {
   iconUrl: $("#map-icon").val(),
   iconSize: [iconWidthAndHeight[0], iconWidthAndHeight[1]],
   popupAnchor: [0, -40],
   setZIndex: 10,
}
let myIcon = L.icon(customIcon);

let iconOptions = {
   title: 'Eccel',
   draggable: false,
   icon: myIcon,
}

// Criando o marcador
let marker = new L.Marker([latitude, longitude], iconOptions);
let address = $("#address").val();
marker.addTo(map);

// Bind do popup com opções
marker.bindPopup(
    `<p>
        <a href="https://maps.app.goo.gl/y1qLmveuoUXLbiv37" target="_blank">
            ${address}
        </a>
    </p>`, {
    autoClose: false,
    closeButton: false,
    closeOnClick: false,
    keepInView: true
}).openPopup();

// prevent popup from closing
// marker.on('click', function (e) {
//     marker.openPopup();
// });

const mapa = document.querySelector('#mapa');